import {json, texture} from "p3";
import common from "../common";
import MinigameChickenRun from "../game/quest/minigames/MinigameChickenRun";
import MinigameDucklingTrain from "../game/quest/minigames/MinigameDucklingTrain";
import MinigameSnakeAttack from "../game/quest/minigames/MinigameSnakeAttack";
import { locale, resizeLabelToFitText } from "../utils";
import GameScene from "./GameScene";
import MenuScene from "./MenuScene";

export default class MinigameResultScene extends MenuScene {
    /**
     * @param {Quest} minigame
     */
    constructor(minigame) {
        super("minigame_result");

        this._minigame = minigame;

        this._panel = null;
        this._title = null;
        this._closeButton = null;
        this._score = null;
        this._coinHolder = null;
    }

    onSceneLoaded() {
        super.onSceneLoaded();

        this.interactive = true;

        this.createFill();

        this._panel = new PIXI.Container();
        this._panel.y = 200;
        this.addChild(this._panel);

        let tile = new PIXI.Sprite(texture("quest_panel_tile"));
        tile.anchor.set(0.5, 0);
        this._panel.addChild(tile);

        tile = new PIXI.Sprite(texture("quest_panel_tile"));
        tile.y = tile.height;
        tile.anchor.set(0.5, 1);
        this._panel.addChild(tile);
        tile.rotation = Math.PI;

        this._panel.header = new PIXI.Sprite(texture("quest_panel_edge"));
        this._panel.header.position.set(0, 10);
        this._panel.header.anchor.set(0.5);
        this._panel.addChild(this._panel.header);

        this._panel.footer = new PIXI.Sprite(texture("quest_panel_edge"));
        this._panel.footer.position.set(0, this._panel.height - 20);
        this._panel.footer.anchor.set(0.5);
        this._panel.addChild(this._panel.footer);

        const deco1 = new PIXI.Sprite(texture("plant_top_left"));
        deco1.position.set(-308, -54);
        this._panel.addChild(deco1);

        const deco2 = new PIXI.Sprite(texture("plant_top_right"));
        deco2.position.set(306, -40);
        deco2.anchor.set(1, 0);
        this._panel.addChild(deco2);

        const deco3 = new PIXI.Sprite(texture("plant_bottom_left"));
        deco3.position.set(-306, this._panel.height - 100);
        deco3.anchor.set(0, 1);
        this._panel.addChild(deco3);

        const deco4 = new PIXI.Sprite(texture("plant_bottom_right"));
        deco4.position.set(306, this._panel.height - 100);
        deco4.anchor.set(1, 1);
        this._panel.addChild(deco4);

        this._title = new PIXI.NineSlicePlane(texture("panel_quest_completed"), 30, 0, 30, 0);
        this._title.position.set(0, -12);
        this._title.pivot.set(0, this._title.texture.height * 0.5);
        this._panel.addChild(this._title);

        this._title.label = new PIXI.BitmapText(locale('ui_minigame_' + (this._minigame.score > 0 ? 'complete' : 'fail') + '_title').toUpperCase(), {
            fontName: "Alghera Pro",
            fontSize: 32,
            align: "center",
            tint: 0x0
        });
        this._title.label.position.set(0, 37);
        this._title.label.anchor.set(0.5);
        this._title.addChild(this._title.label);
        resizeLabelToFitText(this._title, 400);

        this._title.icon = new PIXI.Sprite(texture("icon_npc_quest_complete"));
        this._title.icon.y = -10;
        this._title.icon.anchor.set(0.5);
        this._title.icon.scale.set(1);
        this._title.addChild(this._title.icon);

        this._title.width = this._title.label.textWidth + 50;
        this._title.pivot.x = this._title.width * 0.5;
        this._title.label.x = this._title.width * 0.5;
        this._title.icon.x = this._title.width * 0.5;

        this._avatarLeft = new PIXI.Sprite(texture("dialogue_icon_ivandoe"));
        this._avatarLeft.position.set(-194, 90);
        this._avatarLeft.anchor.set(0.5);
        this._panel.addChild(this._avatarLeft);

        this._avatarRight = new PIXI.Sprite(this.getAvatarTexture());
        this._avatarRight.position.set(194, 90);
        this._avatarRight.anchor.set(0.5);
        this._avatarRight.scale.x = -1;
        this._panel.addChild(this._avatarRight);

        this._copyLabel = new PIXI.BitmapText(locale('ui_minigame_' + (this._minigame.score > 0 ? 'complete' : 'fail') + '_subtitle'), {
            fontName: "Alghera Pro",
            fontSize: 32,
            align: "center",
            tint: 0x938262,
            maxWidth: 320
        });
        this._copyLabel.position.set(0, 106);
        this._copyLabel.anchor.set(0.5);
        this._panel.addChild(this._copyLabel);

        this._score = new PIXI.Container();
        this._score.position.set(-150, 226);
        this._panel.addChild(this._score);

        this._score.frame = new PIXI.NineSlicePlane(texture("quest_frame_9slice"), 40, 40, 40, 40);
        this._score.frame.width = 220;
        this._score.frame.height = 100;
        this._score.frame.pivot.x = this._score.frame.width * 0.5;
        this._score.frame.pivot.y = this._score.frame.height * 0.5;
        this._score.addChild(this._score.frame);

        this._score.icon = new PIXI.Sprite(this.getIconTexture());
        this._score.icon.position.set(-50, 0);
        this._score.icon.anchor.set(0.5);
        this._score.addChild(this._score.icon);

        this._score.valueLabel = new PIXI.BitmapText("x" + this._minigame.score, {
            fontName: "Alghera Pro",
            fontSize: 60,
            align: "center",
            tint: 0x732612
        });
        this._score.valueLabel.position.set(22, 5);
        this._score.valueLabel.anchor.set(0.5);
        this._score.addChild(this._score.valueLabel);

        this._coinHolder = new PIXI.Sprite(texture("panel_coins"));
        this._coinHolder.anchor.set(0.5);
        this._coinHolder.x = 150;
        this._coinHolder.y = this._score.y;
        this._panel.addChild(this._coinHolder);
        
        const coin = new PIXI.Sprite(texture("icon_coin"));
        coin.anchor.set(0.5);
        coin.y = -2;
        this._coinHolder.addChild(coin);
        
        const coinLabel = new PIXI.BitmapText(String(this._minigame.coins * this._minigame.score), {
            fontName: "Alghera Pro",
            fontSize: 32,
            align: "left",
            tint: 0x000000
        });
        coinLabel.anchor.set(0, 0.5);
        coinLabel.x = 17;
        this._coinHolder.addChild(coinLabel);

        this._closeButton = P3.Button.create(texture("btn_action_medium_out"), null, null, texture("btn_icon_medium_tick"));
        this._closeButton.position.set(0, this._panel.height - 140);
        this._closeButton.signals.click.add(this.animateHide, this);
        this._panel.addChild(this._closeButton);

        common.saveData.activeSlot.coins += this._minigame.coins * this._minigame.score;
        common.saveData.saveGame();

        this.resize();

        this.animateShow();
    }

    destroy() {
        this._closeButton.destroy();

        super.destroy();
    }

    resize() {
        super.resize();

        if (this.isSceneLoaded) {
            this._panel.position.x = common.STAGE_WIDTH * 0.5;
        }
    }

    animateShow() {
        
        GameScene.active.addTween(gsap.to(this._panel, 0.7, {y:this._panel.y, ease:Expo.easeOut, onComplete:() => {
            
        }}));
        this._panel.y = -common.STAGE_HEIGHT;
    }

    animateHide() {
        GameScene.active.addTween(gsap.to(this._panel, 0.4, {y:-common.STAGE_HEIGHT, ease:Expo.easeIn, onComplete:() => {
            this.onCloseButtonClick();
        }}));
    }

    onCloseButtonClick() {
        this.signals.next.dispatch(this);
    }

    /**
     * @return {PIXI.Texture}
     */
    getAvatarTexture() {
        try {
            const data = json(this._minigame.owner);
            return texture(data.character.avatar);
        } catch {
        }
        return PIXI.Texture.EMPTY;
    }

    /**
     * @return {PIXI.Texture}
     */
    getIconTexture() {
        if (this._minigame instanceof MinigameChickenRun) {
            return texture("minigame_icon_chicken");
        }
        if (this._minigame instanceof MinigameDucklingTrain) {
            return texture("minigame_icon_duckling");
        }
        if (this._minigame instanceof MinigameSnakeAttack) {
            return texture("minigame_icon_snake");
        }
        return PIXI.Texture.EMPTY;
    }

    /**
     * @return {Quest}
     */
    get minigame() {
        return this._minigame;
    }
}

/**
 * @static
 * @type {GameScene}
 */
MinigameResultScene.active = null;